import { render, staticRenderFns } from "./AddJournalVoucher.vue?vue&type=template&id=497829c8&"
import script from "./AddJournalVoucher.vue?vue&type=script&lang=js&"
export * from "./AddJournalVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports